import { useEffect, useState } from 'react';
import api from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';

export default function FwaSettings() {
  const [settings, setSettings] = useState<any>(null);

  useEffect(() => {
    api.get('/lms/fwa/settings').then((res) => setSettings(res.data.settings));
  }, []);

  const setField = (k: string, v: any) => setSettings((s: any) => ({ ...s, [k]: v }));

  const save = async () => {
    try {
      const res = await api.put('/lms/fwa/settings', {
        enableFlexiPlace: settings.enable_flexi_place,
        enableHalfDayFlexiPlace: settings.enable_half_day_flexi_place,
        enableFlexiTime: settings.enable_flexi_time,
        submissionTiming: settings.submission_timing,
        weeklyLimit: settings.weekly_limit,
        monthlyLimit: settings.monthly_limit,
        syncLeaveCalendar: settings.sync_leave_calendar,
        employeeViewCalendar: settings.employee_view_calendar,
        restrictSameDepartment: settings.restrict_same_department,
        approverViewAll: settings.approver_view_all,
      });
      setSettings(res.data.settings);
      alert('Saved');
    } catch (err: any) {
      alert(err.response?.data?.message || 'Failed to save');
    }
  };

  if (!settings) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">FWA Settings</h1>
      <div className="bg-white rounded-lg shadow p-6 space-y-6">
        <div>
          <h2 className="font-semibold text-gray-800 mb-3">Settings I — Arrangement Types &amp; Limits</h2>
          <div className="grid grid-cols-2 gap-4">
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.enable_flexi_place} onChange={(e) => setField('enable_flexi_place', e.target.checked)} /> Enable Flexi-Place
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.enable_half_day_flexi_place} onChange={(e) => setField('enable_half_day_flexi_place', e.target.checked)} /> Enable Half-Day Flexi-Place
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.enable_flexi_time} onChange={(e) => setField('enable_flexi_time', e.target.checked)} /> Enable Flexi-Time
            </label>
            <Select label="Submission Timing" value={settings.submission_timing} onChange={(e) => setField('submission_timing', e.target.value)}
              options={[{ value: 'ANYTIME', label: 'Anytime' }, { value: 'AFTER_CONFIRMATION', label: 'After Confirmation' }, { value: 'AFTER_3_MONTHS', label: 'After 3 Months' }]} />
            <Input label="Weekly Limit" type="number" value={settings.weekly_limit ?? ''} onChange={(e) => setField('weekly_limit', e.target.value ? Number(e.target.value) : null)} />
            <Input label="Monthly Limit" type="number" value={settings.monthly_limit ?? ''} onChange={(e) => setField('monthly_limit', e.target.value ? Number(e.target.value) : null)} />
          </div>
        </div>
        <div>
          <h2 className="font-semibold text-gray-800 mb-3">Settings II — Calendar &amp; Visibility</h2>
          <div className="grid grid-cols-2 gap-4">
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.sync_leave_calendar} onChange={(e) => setField('sync_leave_calendar', e.target.checked)} /> Sync into Leave Calendar
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.employee_view_calendar} onChange={(e) => setField('employee_view_calendar', e.target.checked)} /> Employees Can View Calendar
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.restrict_same_department} onChange={(e) => setField('restrict_same_department', e.target.checked)} /> Restrict to Same Department
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={settings.approver_view_all} onChange={(e) => setField('approver_view_all', e.target.checked)} /> Approver Sees All
            </label>
          </div>
        </div>
        <Button onClick={save}>Save</Button>
      </div>
    </div>
  );
}
